import {
  configureStore,
} from '@reduxjs/toolkit';
import CustomizerReducer from './customizer/CustomizerSlice';
// Common
import commonReducer from '../slices/Common/commonSlice'
// // admin
import UserManagementReducer from '../slices/admin/UserManagement/UserManagementSlice';
// import CommisionReducer from '../slices/admin/Commission/CommissionSlice';
import CreditDebitReducer from '../slices/admin/CreditDebit/CreditDebitSlice';
import managementReducer from '../slices/admin/Management/managementSlice'; 
// import loadingReducer from '../slices/Loader/loaderSlice';
// // Retailer
import userReducer from '../slices/authSlice/userSilce';
// // user
import dataReducer from '../slices/authSlice/dataSlice';
// // White Label
import WhiteLabelSlice from '../slices/admin/AdminService/whiteLabelSlice';
// Ticket System
import ticketSystemSlice from '../slices/ticketSystem/ticketSystemSlice';

export const store = configureStore(
  {
    reducer: {
      // user
      data: dataReducer,
      // common
      common : commonReducer,
      // Retailer
      customizer: CustomizerReducer,
      user: userReducer,
      // // admin
      UserManagement: UserManagementReducer,
      CreditDebit: CreditDebitReducer,
      managementSlice:managementReducer,
      // // white label
      WhiteLabelSlice: WhiteLabelSlice,
      ticketSystemSlice: ticketSystemSlice,
    },
  },
  // applyMiddleware(CryptoMiddleWare)
);

export default store;
